// Auto-generated by scripts/import_haydock.py — edit with care.
const chapter = {
  book: "Ecclesiasticus (Sirach)",
  bookSlug: "ecclesiasticus",
  chapter: 36,
  argument: "A prayer for the church of God. Of a good heart, and a good wife.",
  verses: [
    { n: 1, text: "Have mercy upon us, O God of all, and behold us, and shew us the light of thy mercies:" },
    { n: 2, text: "And send thy fear upon the nations, that have not sought after thee: that they may know that there is no God beside thee, and that they may shew forth thy wonders." },
    { n: 3, text: "Lift up thy hand over the strange nations, that they may see thy power." },
    { n: 4, text: "For as thou hast been sanctified in us in their sight, so thou shalt be magnified among them in our presence," },
    { n: 5, text: "That they may know thee, as we also have known thee, that there is no God beside thee, O Lord." },
    { n: 6, text: "Renew thy signs, and work new miracles." },
    { n: 7, text: "Glorify thy hand, and thy right arm." },
    { n: 8, text: "Raise up indignation, and pour out wrath." },
    { n: 9, text: "Take away the adversary, and crush the enemy." },
    { n: 10, text: "Hasten the time, and remember the end, that they may declare thy wonderful works." },
    { n: 11, text: "Let him that escapeth be consumed by the rage of the fire: and let them perish that oppress thy people." },
    { n: 12, text: "Crush the head of the princes of the enemies, that say: There is no other beside us." },
    { n: 13, text: "Gather together all the tribes of Jacob: that they may know that there is no God besides thee, and may declare thy great works: and thou shalt inherit them as from the beginning." },
    { n: 14, text: "Have mercy on thy people, upon whom thy name is invoked: and upon Israel, whom thou hast raised up to be thy first-born." },
    { n: 15, text: "Have mercy on Jerusalem, the city which thou hast sanctified, the city of thy rest." },
    { n: 16, text: "Fill Sion with thy unspeakable words, and thy people with thy glory." },
    { n: 17, text: "Give testimony to them that are thy creatures from the beginning, and raise up the prophecies which the former prophets spoke in thy name." },
    { n: 18, text: "Reward them that patiently wait for thee, that thy prophets may be found faithful: and hear the prayers of thy servants," },
    { n: 19, text: "According to the blessing of Aaron over thy people, and direct us into the way of justice, and let all know that dwell upon the earth, that thou art God, the beholder of all ages." },
    { n: 20, text: "The belly will devour all meat, yet one is better than another." },
    { n: 21, text: "The palate tasteth venison, and the wise heart false speeches." },
    { n: 22, text: "A perverse heart will cause grief, and a man of experience will resist it." },
    { n: 23, text: "A woman will receive every man: yet one daughter is better than another." },
    { n: 24, text: "The beauty of a woman cheereth the countenance of her husband, and a man desireth nothing more." },
    { n: 25, text: "If she have a tongue that can cure, and likewise mitigate and shew mercy: her husband is not like other men." },
    { n: 26, text: "He that possesseth a good wife, beginneth a possession: she is a help like to himself, and a pillar of rest." },
    { n: 27, text: "Where there is no hedge, the possession shall be spoiled: and where there is no wife, he mourneth that is in want." },
    { n: 28, text: "Who will trust him that hath no rest, and that lodgeth wheresoever the night taketh him, as a robber well appointed, that skippeth from city to city." },
  ],
  commentary: [
    { verse: 1, notes: [
      { text: "Have. He has pointed out the conditions for prayer, and now he gives a model. The Jews were at this time dispersed and subservient to the Egyptians or Syrians, which greatly afflicted them. (Calmet) — And shew. Greek, (2.) \"send.\"", attribution: "Haydock" }
    ] },
    { verse: 2, notes: [
      { text: "That. Roman Greek omits the rest. But Grabe retains, \"all nations which seek not after thee.\" (Haydock) — This prayer implies a prediction of the Gentiles' conversion, as the psalms do frequently in like terms, Psalm lxiv.", attribution: "Worthington" }
    ] },
    { verse: 4, notes: [
      { text: "Sanctified, by chastising us, or by protecting our fathers in the desert.", attribution: "Haydock" }
    ] },
    { verse: 10, notes: [
      { text: "End of our sufferings. The malice of our enemies is at the height.", attribution: "Haydock" }
    ] },
    { verse: 11, notes: [
      { text: "Escapeth the sword, Deuteronomy xxxii. 36. He foretells the event, or wishes that they may be chastised, in order that they may enter into themselves, and adore the true God.", attribution: "Haydock" }
    ] },
    { verse: 12, notes: [
      { text: "Other lord. The Syrian and Egyptian monarchs sometimes claimed divine honours, Daniel vii. 25., and xi. 36.", attribution: "Calmet" }
    ] },
    { verse: 13, notes: [
      { text: "That. Greek transposes the rest, and has only, and thou, &c.", attribution: "Haydock" }
    ] },
    { verse: 14, notes: [
      { text: "First-born. Exodus iv. 22. Wives, children, and servants, were called after their lord or father, Isaias iv. 1., and lxiii. 19., and Jeremias vii. 10.", attribution: "Haydock" }
    ] },
    { verse: 15, notes: [
      { text: "Rest, where the temple is built, 2 Paralipomenon vi. 41., and Psalm cxxxi. 8.", attribution: "Haydock" }
    ] },
    { verse: 16, notes: [
      { text: "Words, predictions, as heretofore; or with thy favours.", attribution: "Haydock" }
    ] },
    { verse: 18, notes: [
      { text: "Thee. The Jews were more faithful after the captivity. The author seems to beg for the coming of the Messias.", attribution: "Haydock" }
    ] },
    { verse: 19, notes: [
      { text: "People, which thou hast prescribed, Numbers vi. 24. (Calmet) — Direct. Greek, \"All shall know.\" — Art. Greek, \"Lord art the God of ages.\" (Haydock) — Here the prayer ends. (Calmet) — The author continues to instruct.", attribution: "Haydock" }
    ] },
    { verse: 20, notes: [
      { text: "Another. Thus act discreetly in the pursuit of knowledge. The good may be distinguished from bad, as easily as venison can from other meats. (Calmet) — As there is a difference of meats, so must discretion be used in words, in the choice of a wife, &c.", attribution: "Worthington" }
    ] },
    { verse: 22, notes: [
      { text: "Resist. Greek, \"requite it,\" as it deserves.", attribution: "Haydock" }
    ] },
    { verse: 23, notes: [
      { text: "Man. Yet in marriage the temper of the person is to be considered.", attribution: "Haydock" }
    ] },
    { verse: 24, notes: [
      { text: "More. Love is the most violent of all the passions, and nothing can afford greater content than a virtuous and consoling wife, chap. xxvi. 21.", attribution: "Calmet" }
    ] },
    { verse: 26, notes: [
      { text: "Good, is not in Greek, but the context shews that it is necessary. (Haydock) — By concord small possessions increase, as by discord the greatest are lost.", attribution: "Worthington" }
    ] },
    { verse: 27, notes: [
      { text: "Want. If he be not so at first, servants will soon ruin his affairs.", attribution: "Haydock" }
    ] },
    { verse: 28, notes: [
      { text: "Rest, or abode with his wife and family. The Jews in general married, and such as delayed were deemed suspicious characters, Proverbs xxvii. 8.", attribution: "Calmet" }
    ] },
  ],
};

export default chapter;
